// extracted by mini-css-extract-plugin
export default {"invoiceContainer":"GenerateInvoice_invoiceContainer__ySfJD","tablePrint":"GenerateInvoice_tablePrint__8eNiK","tablePrintNone":"GenerateInvoice_tablePrintNone__jf0US"};